import React from 'react';
import BaseModal from 'src/common/components/Modal';

const HighResAlert = ({ open, setOpen, onConfirm, sessions, organo, isSendEmail }) => {
	const getSessionsNumber = () => {
		let newArray = [];

		if (sessions) {
			sessions.forEach((item) => {
				newArray.push(item.sesion);
			});

			let uniqueSesion = [...new Set(newArray)];

			return uniqueSesion.map((item) => ` ${item},`);
			//return sessions.map((item) => ` ${item.sesion},`);
		}
	};
	const getFirtstNumerSesion = () => {
		if (sessions) return sessions[0].sesion;
	};

	const getFirtstIdSession = () => {
		if (sessions) return sessions[0].idSession;
	};
	return (
		<BaseModal
			open={open}
			onConfirm={() =>
				onConfirm(getFirtstIdSession(), getFirtstNumerSesion(), isSendEmail)
			}
			onClose={() => setOpen(true)}
		>
			<h2 class="text-center mb-9">
				<span className="text-danger ">
					Tienes Resoluciones/Recomendaciones para el órgano{' '}
					<b style={{ 'font-weight': 1000 }}>{organo?.nombre}</b> asignadas para
					las sesiones
				</span>
				{getSessionsNumber()}
			</h2>
		</BaseModal>
	);
};

export default HighResAlert;
